<template>
<v-container>
    <div class="d-flex justify-space-between">
        <div style="min-width: 200px">
            <v-tabs v-model="tab" grow class="tab-btn-style">
                <v-tab class="c-tab" v-if="permitObj.upComingClasses">Upcoming Classes</v-tab>
                <v-tab class="c-tab1" v-if="permitObj.completedClasses">Completed Classes</v-tab>
            </v-tabs>
        </div>
        <bread-crumbs :items="breadItems"></bread-crumbs>
    </div>

    <div class="nmt-1">
        <v-tabs-items v-model="tab">
            <v-tab-item>
                <class-table tab="tab" v-if="permitObj.upComingClasses"></class-table>  <!-- Uncoming -->
            </v-tab-item>
            <v-tab-item>
                <past-classes-table tab="tab1" v-if="permitObj.completedClasses"></past-classes-table>
            </v-tab-item>

        </v-tabs-items>
    </div>
</v-container>
</template>

<script>
import BreadCrumbs from "../../../components/BreadCrumbs";
import ClassTable from "../../../components/StudentPanel/classes/ClassTable.vue";
import PastClassesTable from "../../../components/StudentPanel/classes/PastClassesTable.vue";
import { getPermitObjects } from '../../../utils/allowedPermissions';

export default {
    name: "Classes",
    components: {
        ClassTable,
        BreadCrumbs,
        PastClassesTable
    },
    data() {
        return {
            tab: null,
            permitObj : {} ,
            breadItems: [{
                    text: "Dashboard",
                    disabled: false,
                    href: "/",
                    to: {
                        name: "DashBoard"
                    }
                },
                {
                    text: this.$route.meta.title,
                    disabled: true,
                    to: {
                        name: this.$route.name
                    }
                }
            ]
        };
    },
    methods: {
        getPermittedArray() {
            let links = this.$store?.getters?.permissions;
            let pathName = "SPStudentClasses";
            this.permitObj = getPermitObjects(links, pathName);
            console.log(this.permitObj);
        },
    },
    mounted() {
        this.getPermittedArray();
    },
};
</script>

<style scoped>
</style>
